<template>
  <div class="attachment" :style="{'margin-top': 36 * (index+1) + 'px'}">
    <slot v-if="itemType === 'resource'">
      <div class="resource-annotation-block-indicator" :style="{background: 'orange'}"></div>
    </slot>
    <slot v-else-if="itemType === 'annotation'">
      <div class="resource-annotation-block-indicator" :style="{background: 'blue'}"></div>
    </slot>
    <slot v-else-if="itemType === 'mixed'">
      <div class="resource-annotation-block-indicator">
        <div class="resource-annotation-block-indicator-half" :style="{background: 'orange'}"></div>
        <div class="resource-annotation-block-indicator-half" :style="{background: 'blue'}"></div>
      </div>
    </slot>
    <div class="resource" v-if="resourcePanelOpen" @click="open()">
      <img class="resource-type" :src="img" />
      <div class="resource-title">{{title}}</div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  export default {
    name: 'ResourcePanelViewItem',
    props: {
      img: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      open: {
        type: Function,
        required: true
      },
      resourcePanelOpen: {
        type: Boolean,
        required: true
      },
      itemType: {
        type: String,
        required: true
      },
      index: {
        type: Number,
        required: false,
        default: 0
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.attachment {
  position: absolute;
  cursor: pointer;
  font-size: 0;
  background: $background-color;
  margin-bottom: 2px;
  z-index: 600;

  :hover {
    background: $background-color-dark;
  }

  .resource-annotation-block-indicator, .unread-block-indicator {
    width: 6px;
    display: inline-block;
    height: 34px;
  }

  .resource-annotation-block-indicator-half {
    width: 6px;
    display: block;
    height: 17px;
  }

  .resource {
    font-size: 12pt;
    display: inline-block;
    height: 34px;
  }
  
  .resource-type {
    width: 34px;
  }

  .resource-title {
    display: inline-block;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
    margin-top: 3px;
    margin-left: 5px;
  }
}

</style>


